import { useEffect } from "react";

const useDebouncedUpdate = (updater: () => void, dependencies: any[]) => {
    useEffect(() => {
        const handler = setTimeout(() => {
            updater();
        }, 300);

        return () => {
            clearTimeout(handler);
        };
        // No need to run this function when the update function changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...dependencies]);
};

export default useDebouncedUpdate;
